const smmServicesData = [
  {
    title: "Strategy",
    description:
      "Define channel mix, audience segments, and content pillars aligned to objectives and KPIs.",
    bullets: ["Calendar", "Personas", "Themes", "KPIs"],
    minHeight: 400,
  },
  {
    title: "Content",
    description:
      "End‑to‑end asset production and publishing with design, copy, video, and brand QA.",
    bullets: ["Design", "Copy", "Video", "Publish"],
    minHeight: 400,
  },
  {
    title: "Community",
    description:
      "Grow communities through real‑time engagement, moderation, and influencer collaboration.",
    bullets: ["Replies", "Moderation", "Influencers", "UGC"],
    minHeight: 400,
  },
  {
    title: "Growth",
    description:
      "Execute growth campaigns and co‑marketing collaborations with measurable outcomes.",
    bullets: ["Giveaways", "Partnerships", "Collabs", "Ads"],
    minHeight: 400,
  },
  {
    title: "Analytics",
    description:
      "Analytics dashboards for KPIs, funnel performance, content insights, and recommendations.",
    bullets: ["KPIs", "Funnels", "Content", "Reports"],
    minHeight: 400,
  },
  {
    title: "Support",
    description:
      "Always‑on operations with playbooks, approvals, governance, and archive policies.",
    bullets: ["Playbooks", "SLAs", "Approvals", "Archive"],
    minHeight: 400,
  },
  {
    title: "Paid Social",
    description:
      "Plan and run performance campaigns with rigorous creative testing and audience strategy.",
    bullets: ["Audience", "Creatives", "A/B", "Budget"],
    minHeight: 400,
  },
  {
    title: "UGC & Influencers",
    description:
      "Build UGC and influencer programs with clear guidelines, briefs, and performance tracking.",
    bullets: ["UGC", "Creators", "Guidelines", "Tracking"],
    minHeight: 400,
  },
  {
    title: "Crisis Response",
    description:
      "Crisis monitoring with templates, escalation paths, and debrief reports for continuous improvement.",
    bullets: ["Monitoring", "Templates", "Escalation", "Reports"],
    minHeight: 400,
  },
];

export default smmServicesData;
